export default "__VITE_PUBLIC_ASSET__9c5b3e37__"